<div
  class="px-app-x-m md:px-app-x-d flex flex-col items-center py-16px md:py-40px"
>
  <ul class="flex justify-center items-center flex-col md:flex-row">
    <li>
      <a
        mat-button
        class="ib-btn ib-btn-link ib-btn-secondary"
        target="_blank"
        href="https://www.investabill.com/privacy/"
        >Privacy</a
      >
    </li>
    <li>
      <a
        mat-button
        class="ib-btn ib-btn-link ib-btn-secondary"
        target="_blank"
        href="https://www.investabill.com/gdpr/"
        >GDPR</a
      >
    </li>
    <li>
      <a
        mat-button
        class="ib-btn ib-btn-link ib-btn-secondary"
        target="_blank"
        href="https://www.investabill.com/confidentiality/"
        >Confidentiality</a
      >
    </li>
    <li>
      <a
        mat-button
        class="ib-btn ib-btn-link ib-btn-secondary"
        target="_blank"
        href="https://www.investabill.com/rules/"
        >Rules</a
      >
    </li>
    <li>
      <a
        mat-button
        class="ib-btn ib-btn-link ib-btn-secondary"
        target="_blank"
        href="https://www.investabill.com/complaints/"
        >Complaints</a
      >
    </li>
    <li>
      <a
        mat-button
        class="ib-btn ib-btn-link ib-btn-secondary"
        target="_blank"
        href="https://www.investabill.com/fraud/"
        >Fraud</a
      >
    </li>
    <li>
      <a
        mat-button
        class="ib-btn ib-btn-link ib-btn-secondary"
        target="_blank"
        href="https://www.investabill.com/ratings-policy/"
        >Ratings</a
      >
    </li>
    <li>
      <a
        mat-button
        class="ib-btn ib-btn-link ib-btn-secondary"
        target="_blank"
        href="https://www.investabill.com/buy-rates/"
        >Buy Rates</a
      >
    </li>
  </ul>

  <div class="flex flex-col sm:flex-row justify-center items-center mt-24px">
    <a
      href="tel:+35316853665"
      class="flex w-160px justify-center md:justify-end items-center"
      ><i class="material-icons text-secondary! text-18px">phone</i>&nbsp;<span
        class="text-14px"
        >+353 1 685-3665</span
      ></a
    >
    <span class="text-18px mx-24px hidden sm:inline-block text-border-d"
      >|</span
    >
    <a
      href="mailto:yield@investabill.com"
      class="flex w-160px justify-center md:justify-start items-center mt-16px sm:mt-0"
      ><i class="material-icons text-secondary! text-18px">email</i>&nbsp;<span
        class="text-14px"
        >yield@investabill.com</span
      ></a
    >
  </div>
  <div class="text-12px text-center mt-24px">
    © Credebt Exchange Limited 2011 – {{ year }}.
  </div>
</div>
